import Axios from 'axios'
import React, { FormEvent, useEffect, useState } from 'react'
import { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export const EditPayer: FunctionComponent = () => {
  const [disabled, setDisabled] = useState(false)
  const [name, setName] = useState('')
  const [inn, setInn] = useState('')

  const { payerId } = useParams<{ payerId: string }>()

  useEffect(() => {
    const loadPayer = async () => {
      setDisabled(true)

      try {
        const payer = await Axios.get<{
          name: string
          inn: string
        }>(`${process.env.REACT_APP_API_URL}/api/v1/payers/${payerId}`)

        setName(payer.data.name)
        setInn(payer.data.inn)
      } finally {
        setDisabled(false)
      }
    }

    loadPayer()
  }, [payerId])

  const editPayer = async (_: FormEvent) => {
    _.preventDefault()

    setDisabled(true)

    try {
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/payers/${payerId}`,
        {
          name,
          inn,
        }
      )

      toast.success('Плательщик обновлён.')
    } finally {
      setDisabled(false)
    }
  }

  return (
    <div className="row">
      <div className="col">
        <form onSubmit={editPayer}>
          <fieldset disabled={disabled}>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label>Название</label>
                  <input
                    className="form-control"
                    required
                    type="text"
                    value={name}
                    onChange={(_) => setName(_.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>ИНН</label>
                  <input
                    className="form-control"
                    required
                    type="text"
                    value={inn}
                    onChange={(_) => setInn(_.target.value)}
                  />
                </div>
                <button type="submit" className="btn btn-success">
                  <i className="fas fa-save"></i> Сохранить
                </button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  )
}
